import { render } from "./E-signature.vue?vue&type=template&id=4b4a5973&scoped=true"
import script from "./E-signature.vue?vue&type=script&lang=js"
export * from "./E-signature.vue?vue&type=script&lang=js"

import "./E-signature.vue?vue&type=style&index=0&id=4b4a5973&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4a5973"]])

export default __exports__